import {defineStore} from 'pinia'
import CustomStore from "devextreme/data/custom_store";
// import { useAbsenStore } from "@/stores/views/absen-store";
import {ref} from "vue";
import _ from "lodash";
import axios from "axios";
import {API_BASE_URL} from "@/global-constants";
import api from "@/api";
// import {DateTime} from "luxon";
import { useRoute } from "vue-router";
export const useAbsenModel = defineStore(
    'absenModel',
    () => {
        const route = useRoute();
        const summary = ref(null);
        // const periodeAbsen = DateTime.now().set({ day: 1 }).toFormat("yyyy-MM-dd");
       
        function convertColumnName(name, columns) {
            for (const column of columns) {
                const pattern = new RegExp(`^${column}_`);
                if (pattern.test(name)) {
                    return name.replace(pattern, `${column}.`);
                }
            }
            return name;
        }
        
        function convertArrayElements(arr, columns) {
            return _.map(arr, element => {
                if (_.isArray(element)) {
                    return convertArrayElements(element, columns);
                } else if (_.isString(element)) {
                    return convertColumnName(element, columns);
                }
                return element;
            });
        }

        const latestAccessTime = ref(null);
        const absenCustomStore = new CustomStore({
            load: async (mergedLoadOptions) => {
                let loadOptions = mergedLoadOptions[0];
                let additionalParams = mergedLoadOptions[1];
                const columns = ['gajis', 'simpeg_pegawais', 'jabatans', 'cabangs', 'units', 'pegawai_statuses',  'sub_bagians', 'bagians', 'bidangs', 'sub_bidangs', 'seksis', 'status_aktifs'];
                
               
                let params = {};
                params.sort = "";params.filter="";
                if (loadOptions.sort) {
                    if (typeof loadOptions.sort[0].selector === 'function') {
                        loadOptions.sort[0].selector= loadOptions.sort[0].selector.context.column.dataField;
                    }
                    params.sort = JSON.stringify(convertArrayElements(loadOptions.sort, columns));
                    params.sort =  params.sort.replace(/jabatans_nama/g, 'jabatans_id');
                    params.sort =  params.sort.replace(/pegawai_statuses_nama/g, 'pegawai_statuses_id');
                }
               
                
                if (loadOptions.filter) {
                    loadOptions.filter = processLoadArray(loadOptions.filter); //benerin format tanggal
                    let temp = [];
                    if(route.query.filter){
                       temp = route.query.filter;
                    }else{
                        temp = removeFilterCriteria( loadOptions.filter, 'pegawai_id');
                    }
                    temp = convertArrayElements(loadOptions.filter, columns)
                    params.filter = JSON.stringify(temp);

                }


               // ================FILTER DEFAULT --> filter pegawai yang aktif
                loadOptions.filterDefault = [];
                if(params.filter === ""){
                    loadOptions.filterDefault.push(['simpeg_pegawais.status_aktif_id', '=', '1']);
                    if(additionalParams) loadOptions.filterDefault.push("and");
                }
            
                if (additionalParams) {
                    var coba = convertArrayElements(additionalParams, columns);
                    
                    loadOptions.filterDefault.push(coba);
                }
                
                params.filterDefault = JSON.stringify(loadOptions.filterDefault );

                //================SORT DEFAULT --> sort jabatan_id asc, nik
                loadOptions.sortDefault = [];
                // if(!params.sort.includes("jabatans.nama")){
                //     loadOptions.sortDefault.push({"selector":"jabatans.id","desc":false});
                // }
                // if(!params.sort.includes("nik")){
                //     loadOptions.sortDefault.push({"selector":"nik","desc":false});
                // }
                if(params.sort === ""){
                    loadOptions.sortDefault.push({"selector":"periode_absen","desc":true});
                    loadOptions.sortDefault.push({"selector":"jabatans.id","desc":false});
                    loadOptions.sortDefault.push({"selector":"nik","desc":false});
                }
                    
                params.sortDefault = JSON.stringify(loadOptions.sortDefault );

                ////////////////////////////////////

                if (loadOptions.skip) {
                    params.skip = loadOptions.skip;
                }

                if (loadOptions.take) {
                    params.take = loadOptions.take;
                }

               

                const response = await axios.get(`${API_BASE_URL}/customstore-absen-bulans`, {
                    params: params,
                    headers: {
                        Authorization: api.defaults.headers.common['Authorization'],
                        'Content-Type': 'application/json',
                    },
                });

                
        
          
              
                if (response.data) {

                  
                
                    return {
                        data: response.data.data,
                        totalCount: response.data.totalCount,
                        summary: response.data.summary
               
                    };
                }

                throw 'Data loading error';


               
            },
        });

        function removeFilterCriteria(filter, field) {
            // Check if filter is an array
            if (Array.isArray(filter)) {
              // Check if filter is a single array condition and matches the field criteria
              if (filter.length >= 3 && filter[0] === field) {
                return []; // Return an empty array to remove this filter condition
              } else {
                // Filter out sub-filters that match the field to remove
                return filter.filter(subFilter => {
                  // Recursively apply the function to nested arrays
                  if (Array.isArray(subFilter)) {
                    return removeFilterCriteria(subFilter, field).length > 0; // Keep if not empty after filtering
                  }
                  // Keep other elements (like 'and', 'or', etc.)
                  return true;
                }).map(subFilter => {
                  // Recursively apply the function to nested arrays
                  if (Array.isArray(subFilter)) {
                    return removeFilterCriteria(subFilter, field);
                  }
                  return subFilter;
                });
              }
            }
            // Return the filter as-is if it's not an array or doesn't match the expected structure
            return filter;
          }
          
       

        function processLoadArray(loadArray) {
            return _.map(loadArray, item => {
                if (_.isArray(item)) {
                    // Check if 'periode_absen' is present in the sub-array
                    if (_.includes(item, 'periode_absen')) {
                        // Map through the sub-array to find and convert Date objects
                        return _.map(item, subItem => {
                            return subItem instanceof Date ? formatDateToISOString(subItem) : subItem;
                        });
                    } else {
                        // Recursively process nested arrays
                        return processLoadArray(item);
                    }
                }
                return item;
            });
        }

        // function adaPeriodeAbsen(filter){
        //     if (Array.isArray(filter)) {
        //         // Check if the current filter array contains 'periode_absen'
        //         if (filter.length === 3 && filter[0] === 'periode_absen') {
        //           return true;
        //         }
        //         // Recursively check each element in the filter array
        //         return filter.some(subFilter => adaPeriodeAbsen(subFilter));
        //       }
        //       return false;
            
        // }

        // function adaPegawaiId(filter){
        //     if (Array.isArray(filter)) {
        //         // Check if the current filter array contains 'periode_absen'
        //         if (filter.length === 3 && filter[0] === 'pegawai_id') {
        //           return true;
        //         }
        //         // Recursively check each element in the filter array
        //         return filter.some(subFilter => adaPeriodeAbsen(subFilter));
        //       }
        //       return false;
            
        // }

        function formatDateToISOString(date) {
            function pad(n) { return n < 10 ? '0' + n : n }
            return date.getFullYear() + '-' +
                pad(date.getMonth() + 1) + '-' +
                pad(date.getDate());
        }


        return {
            absenCustomStore,
            summary,
            latestAccessTime,
            // selectedBulanBacaDataGrid,
           
        }
    });